export * from './SyntheticDOM';


//////////////////
// WEBPACK FOOTER
// ../synthetic-dom/esm/main.js
// module id = 1034
// module chunks = 25